import React from 'react';
import { Box, Container, styled, Typography } from '@mui/material';
import { CurrentRequestedDocumentTableFooterProps } from './types';

const PREFIX = 'CurrentRequestedDocumentTableFooter';

const classes = {
  footer: `${PREFIX}-footer`,
  footerText: `${PREFIX}-footerText`,
  buttonContainer: `${PREFIX}-buttonContainer`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.footer}`]: {
    alignItems: 'center',
    backgroundColor: theme?.palette?.grey?.[200],
    bottom: 0,
    display: 'flex',
    justifyContent: 'space-between',
    left: 0,
    position: 'fixed',
    width: '100dvw',
    zIndex: 1000,
  },

  [`& .${classes.footerText}`]: {
    textAlign: 'center',
  },

  [`& .${classes.buttonContainer}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
}));

const CurrentRequestedDocumentTableFooter = ({ currentDocuments }: CurrentRequestedDocumentTableFooterProps) => (
  <Root>
    <Box component="footer" className={classes.footer}>
      <Container maxWidth="lg" className={classes.buttonContainer}>
        <Typography variant="body2" color="textSecondary" className={classes.footerText}>
          {currentDocuments?.files?.length} Document(s) | {currentDocuments?.folders?.length} Subfolder(s)
        </Typography>
      </Container>
    </Box>
  </Root>
);

export default CurrentRequestedDocumentTableFooter;
